export class ParserError extends Error {}

export function isParserError(err: unknown): err is ParserError {
  return err instanceof ParserError;
}
